import * as THREE from 'three'

const allChickens = ['blue', 'darkblue', 'darkgreen', 'green', 'orange', 'pink', 'red', 'yellow']
const tailPositions = ['left', 'right']
let currentStep = 0
const selectedChickens = []
let buildingModel1 = null
let buildingModel2 = null
let buildingModel3 = null
// Play Sound
const bgMusic = new window.Howl({
  src: ['/projects/coloane-macau/ar/colourful-roosters/sound/joyful.mp3'],
  volume: 1,
  autoplay: false,
  loop: false,
})

// Play Sound
const sound = new window.Howl({
  src: ['/projects/coloane-macau/ar/colourful-roosters/sound/treasure.mp3'],
  volume: 4,
  autoplay: false,
  loop: false,
})

function findModel(targetImage) {
  // Building Model
  const casa = document.getElementById('casa-entity')
  const edificio = document.getElementById('edificio-entity')
  const farol = document.getElementById('farol-entity')
  const igreja = document.getElementById('igreja-entity')
  const largo = document.getElementById('largo-entity')
  const quartel = document.getElementById('quartel-entity')
  const ruinas = document.getElementById('ruinas-entity')
  const templo = document.getElementById('templo-entity')

  let selectedObject = null

  if(targetImage === 'chicken_blue_left' || targetImage === 'chicken_blue_right') {
    selectedObject = quartel
  } else if(targetImage === 'chicken_darkblue_left' || targetImage === 'chicken_darkblue_right') {
    selectedObject = farol
  } else if(targetImage === 'chicken_darkgreen_left' || targetImage === 'chicken_darkgreen_right') {
    selectedObject = igreja
  } else if(targetImage === 'chicken_green_left' || targetImage === 'chicken_green_right') {
    selectedObject = ruinas
  } else if(targetImage === 'chicken_orange_left' || targetImage === 'chicken_orange_right') {
    selectedObject = casa
  } else if(targetImage === 'chicken_pink_left' || targetImage === 'chicken_pink_right') {
    selectedObject = edificio
  } else if(targetImage === 'chicken_red_left' || targetImage === 'chicken_red_right') {
    selectedObject = templo
  } else if(targetImage === 'chicken_yellow_left' || targetImage === 'chicken_yellow_right') {
    selectedObject = largo
  } 
  

  return selectedObject
}

function getRandom(num1, num2) {
  if (!num1) {
    return Math.floor(Math.random() * allChickens.length)
  }

  if (num1) {
    const randNum = Math.floor(Math.random() * allChickens.length)
    if (num1 === randNum) {
      return getRandom(num1)
    } else {
      return randNum
    }
  }

  if (num1 && num2) {
    const randNum = Math.floor(Math.random() * allChickens.length)

    if (num1 === randNum || num2 === randNum) {
      return getRandom(num1, num2)
    } else {
      return randNum
    }
  }
}

const num1 = getRandom()
const num2 = getRandom(num1)
const num3 = getRandom(num1, num2)

// const targetImage1 = `chicken_${allChickens[num1]}_${tailPositions[Math.floor(Math.random() * 2)]}`
// const targetImage2 = `chicken_${allChickens[num2]}_${tailPositions[Math.floor(Math.random() * 2)]}`
// const targetImage3 = `chicken_${allChickens[num3]}_${tailPositions[Math.floor(Math.random() * 2)]}`

const targetImage1 = `chicken_${allChickens[num1]}_left`
const targetImage2 = `chicken_${allChickens[num1]}_right`
const targetImage3 = `chicken_${allChickens[num2]}_left`
const targetImage4 = `chicken_${allChickens[num2]}_right`
const targetImage5 = `chicken_${allChickens[num3]}_${tailPositions[Math.floor(Math.random() * 2)]}`

selectedChickens.push(targetImage1)
selectedChickens.push(targetImage2)
selectedChickens.push(targetImage3)
selectedChickens.push(targetImage4)
selectedChickens.push(targetImage5)



// console.log('selectedChickens', selectedChickens)

const colourfulRoostersComponent = {
  init() {
    // Scene
    let found = false
    const scene = this.el.sceneEl
    const {object3D} = this.el
    const {sceneEl} = this.el

    // UI
    const findingUI = document.getElementById('finding')
    const foundUI = document.getElementById('found')
    const targetImageBtn = document.getElementById('target-image-button')
    const lightbox = document.getElementById('lightbox')
    const recorder = document.getElementById('recorder')
    const processingUI = document.getElementById('processing-ui')
    const finishUI = document.getElementById('finish-ui')
    const lightboxImg = document.getElementById('lightbox-img')
    const targetImage = document.getElementById('target-image')

    // Update Page Title
    document.title = "葡國公雞 AR | 悠路環 Arraial em Coloane"
    // gtag('config', 'G-SK1FT0PPXT', {
    //     page_title : '葡國公雞 AR | 悠路環 Arraial em Coloane',
    //     page_location: 'https://webar.coloane-macau.com/explore-the-church' // The full URL is required.
    // });

    // Shop
    const assets = document.querySelector('a-assets')

    // AR
    const aScene = document.getElementById('a-scene')

    // control
    const arContent = document.getElementById('ar-content')
    const arContentPosition = '0 0 0'
    const arContentScale = 0.5
    const modelInfo = {
      scale: '1 1 1',
      position: '0 -0.5 0.5',
      rotation: '0 360 0',
    }
    const targetImageSlug = ''

    // Dot
    const setpDot1 = document.getElementById('step-1-dot')
    const setpDot2 = document.getElementById('step-2-dot')
    const setpDot3 = document.getElementById('step-3-dot')

    // Dot icon
    const setIcon1 = document.getElementById('tick-1-icon')
    const setIcon2 = document.getElementById('tick-2-icon')
    const setIcon3 = document.getElementById('tick-3-icon')

    // Model
    const ribbon = document.getElementById('ribbon-entity')
    const light = document.getElementById('light-entity')

    // play bg music
    bgMusic.play()

    // update target image
    lightboxImg.src = `/projects/coloane-macau/ar/colourful-roosters/target-image/${selectedChickens[currentStep]}.jpg`
    targetImage.src = `/projects/coloane-macau/ar/colourful-roosters/target-image/${selectedChickens[currentStep]}.jpg`

    

    // Set up aScene
    aScene.setAttribute('target-image-control', `images: ${selectedChickens[0]}, ${selectedChickens[1]}, ${selectedChickens[2]}, ${selectedChickens[3]}, ${selectedChickens[4]}`)
    aScene.setAttribute('back-btn-control', {
      page: 'colourful-roosters',
    })
    aScene.setAttribute('loading-screen', {
      title: 'colourful-roosters',
    })

    


    // Update AR Content
    arContent.setAttribute('scale', `${arContentScale} ${arContentScale} ${arContentScale}`)
    arContent.setAttribute('position', arContentPosition)

    // Show Target Image popup
    targetImageBtn.addEventListener('click', (event) => {
      lightbox.style.display = 'flex'
    })

    lightbox.addEventListener('click', (event) => {
      lightbox.style.display = 'none'
    })

    // AR Camera Ready
    const showObject = ({detail}) => {
      // findingUI.style.display = 'none'
      processingUI.style.display = 'block'

      // console.log('currentStep:', currentStep)
      // console.log('name:', detail.name)
      if(!found) {
          buildingModel1 = findModel(selectedChickens[0])
          buildingModel2 = findModel(selectedChickens[2])
          buildingModel3 = findModel(selectedChickens[4])
      }

      // Step 1
      if ((detail.name === selectedChickens[0] || detail.name === selectedChickens[1]) && currentStep === 0) {
        // Play Sound
        sound.play()

        // Show Ribbon
        setTimeout(() => {
          ribbon.setAttribute('visible', 'true')
          ribbon.setAttribute('animation__scale', {
            property: 'scale',
            to: '0.2 0.2 0.2',
            dur: 2000,
            easing: 'easeOutElastic',
          })

          ribbon.setAttribute('animation-mixer', {
            clip: 'Anim_0',
            loop: 'repeat',
          })


         
          buildingModel1.setAttribute('visible', 'true')
          buildingModel1.setAttribute('animation__scale', {
            property: 'scale',
            to: '0.3 0.3 0.3',
            dur: 2000,
            easing: 'easeOutElastic',
          })
        }, 500)

        // Hide Ribbon
        setTimeout(() => {
          ribbon.setAttribute('visible', 'false')
          
        }, 3000)

        // Hide Bilding
        setTimeout(() => {
          buildingModel1.setAttribute('animation__scale', {
            property: 'scale',
            to: '0.01 0.01 0.01',
            dur: 2000,
            easing: 'easeOutElastic',
          })

          setTimeout(() => {
            buildingModel1.setAttribute('visible', 'false')
          }, 2000)
        }, 3000)

        // update UI
        setIcon1.style.display = 'block'
        setpDot2.classList.add('bg-coloane-green')

        currentStep = 2
        lightboxImg.src = `/projects/coloane-macau/ar/colourful-roosters/target-image/${selectedChickens[currentStep]}.jpg`
        targetImage.src = `/projects/coloane-macau/ar/colourful-roosters/target-image/${selectedChickens[currentStep]}.jpg`
      }
      // Step 2
      else if ((detail.name === selectedChickens[2] || detail.name === selectedChickens[3]) && currentStep === 2) {
        // console.log('In side Step 2')
        
        // Play Sound
        sound.play()

        // Show Ribbon
        setTimeout(() => {
          ribbon.setAttribute('visible', 'true')
          ribbon.setAttribute('animation__scale', {
            property: 'scale',
            to: '0.2 0.2 0.2',
            dur: 2000,
            easing: 'easeOutElastic',
          })

          ribbon.setAttribute('animation-mixer', {
            clip: 'Anim_0',
            loop: 'repeat',
          })

          
          buildingModel2.setAttribute('visible', 'true')
          buildingModel2.setAttribute('animation__scale', {
            property: 'scale',
            to: '0.3 0.3 0.3',
            dur: 2000,
            easing: 'easeOutElastic',
          })
        }, 500)

        // Hide Ribbon
        setTimeout(() => {
          ribbon.setAttribute('visible', 'false')
        }, 3000)

        // Hide Bilding
        setTimeout(() => {
          buildingModel2.setAttribute('animation__scale', {
            property: 'scale',
            to: '0.01 0.01 0.01',
            dur: 2000,
            easing: 'easeOutElastic',
          })

          setTimeout(() => {
            buildingModel2.setAttribute('visible', 'false')
          }, 2000)
        }, 3000)

        // update UI
        setIcon2.style.display = 'block'
        setpDot3.classList.add('bg-coloane-green')

        currentStep = 4
        lightboxImg.src = `/projects/coloane-macau/ar/colourful-roosters/target-image/${selectedChickens[currentStep]}.jpg`
        targetImage.src = `/projects/coloane-macau/ar/colourful-roosters/target-image/${selectedChickens[currentStep]}.jpg`
      }
      // Step 3
      else if (detail.name === selectedChickens[4] && currentStep === 4) {
        // console.log('In side Step 3')
        
        // Play Sound
        sound.play()

        // Show Ribbon
        setTimeout(() => {
          ribbon.setAttribute('visible', 'true')
          ribbon.setAttribute('animation__scale', {
            property: 'scale',
            to: '0.2 0.2 0.2',
            dur: 2000,
            easing: 'easeOutElastic',
          })

          ribbon.setAttribute('animation-mixer', {
            clip: 'Anim_0',
            loop: 'repeat',
          })

          
          buildingModel3.setAttribute('visible', 'true')
          buildingModel3.setAttribute('animation__scale', {
            property: 'scale',
            to: '0.3 0.3 0.3',
            dur: 2000,
            easing: 'easeOutElastic',
          })
        }, 500)

        // Hide Ribbon
        setTimeout(() => {
          ribbon.setAttribute('visible', 'false')
        }, 3000)

        // Hide Bilding
        setTimeout(() => {
          buildingModel3.setAttribute('animation__scale', {
            property: 'scale',
            to: '0.01 0.01 0.01',
            dur: 2000,
            easing: 'easeOutElastic',
          })

          setTimeout(() => {
            buildingModel3.setAttribute('visible', 'false')
          }, 2000)
        }, 3000)

        // update UI
        setTimeout(() => {
          finishUI.style.display = 'block'
          findingUI.style.display = 'none'
        }, 3000)
        
        setIcon3.style.display = 'block'

        currentStep++
      }

      

      object3D.position.copy(detail.position)
      object3D.quaternion.copy(detail.rotation)
      object3D.scale.set(detail.scale, detail.scale, detail.scale)
      found = true
    }

    scene.addEventListener('xrimagefound', showObject)
    scene.addEventListener('xrimageupdated', showObject)
  },
}

export {
  colourfulRoostersComponent,
}
